<template>
  <div class="modal inset-0">
    <div class="container text-center modal-container">
      <button @click="closeModal" class="modal-close">
        <i class="fas fa-times text-2xl"></i>
      </button>
      <v-zoomer style="width: 100%; height: 100vh;">
        <img
          :src="image"
          draggable="false"
          style="object-fit: contain; width: 100%; height: 100%;"
        >
      </v-zoomer>
    </div>
  </div>
</template>

<script>
import modalMixin from '../../../mixins/modal-mixins'

export default {
  mixins: [modalMixin],
  name: 'BaseZoomImage',
  props: { image: { type: String } }
}
</script>

<style scoped>
.modal-container {
  padding: 0;
  margin: 0 auto;
}
</style>
